<template>
	<div class="home-container fade-in">
		<!-- Swiper轮播图 -->
		<div class="swiper-container">
			<div class="swiper-wrapper" v-if="banner.length">
				<div class="swiper-slide" v-for="item in banner" :key="item.id" @click="naviToBannerDetails(item)">
					<img :src="item.img" class="carousel-image">
				</div>
			</div>
			<!-- 方形指示器 -->
			<div class="swiper-pagination"></div>
		</div>
		<!-- 最受欢迎画师榜 -->
		<div class="popular-artists-container">
			<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
			<div class="container-title-box">
				<div class="title">
					最受欢迎画师榜
					<div class="subTitle">
						TOP POPULAR AI ARTIST
					</div>
				</div>
			</div>
			<div class="rank-container">
				<div class="rank-item" v-for="(row,rowIndex) in artists" :key="rowIndex">
					<div class="item-title">
						{{row.title}}
					</div>
					<div class="item-menu">
						<div class="rank">排名</div>
						<div class="nickname">昵称</div>
					</div>
					<div class="item-artists-list">
						<div class="artist" v-for="(item,index) in row.children" :key="item.id">
							<div class="rankText">
								{{index > 2 ? index + 1 : ''}}
								<img class="rankImg" src="../assets/Home/first.png" v-if="index == 0" />
								<img class="rankImg" src="../assets/Home/second.png" v-if="index == 1" />
								<img class="rankImg" src="../assets/Home/third.png" v-if="index == 2" />
							</div>
							<div class="avatarNickname" @click="naviToPainter(item)">
								<img class="avatar" :src="item.avatar" v-if="item.avatar" />
								<img class="avatar" src="../assets/defaultAvatar.png" v-else />
								<div class="nickname">{{item.user_nickname}}</div>
							</div>
						</div>
					</div>
					<router-link :to="{path: '/popular-artists',query: {type:rowIndex}}" class="look-more">
						查看更多榜单 》
					</router-link>
				</div>
			</div>
		</div>
		<!-- 官方推荐 -->
		<div class="offical-recommendation-container">
			<div class="container-title-box">
				<div class="title">
					官方推荐
					<div class="subTitle">
						EDITOR’S PICKS
					</div>
				</div>
			</div>
			<div class="swiper-container-official" v-if="huaList.length">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in huaList" :key="index">
						<img :src="item.img" :alt="item.title" class="official-image"
							@click="$router.push({path: '/work-details',query: {id:item.id,userId: item.user_id,type: 5}})">
					</div>
				</div>
				<div class="swiper-button-prev-official">
					<img class="arrowIcon" src="../assets/Home/leftArrow.png" />
				</div>
				<div class="swiper-button-next-official">
					<img class="arrowIcon" src="../assets/Home/rightArrow.png" />
				</div>
			</div>
			<router-link to="/official-recommend" class="view-more-official">
				查看更多 》
			</router-link>
		</div>
		<!-- 平台超话排名 -->
		<div class="latform-hypertalk-ranking-container">
			<div class="container-title-box">
				<div class="title">
					平台超话排名
					<div class="subTitle">
						TRENDING TOPICS LEADERBOARD
					</div>
				</div>
			</div>
			<div class="hypertalkRankingList">
				<div class="hypertalkRankingItem" v-for="(item,index) in community" :key="index"
					@click="naviToSuperTalkDetails(item)">
					<img class="itemIcon" :src="item.img" />
					<div class="itemTitleBox">
						<div class="title">TOP{{index + 1}}</div>
						<div class="cate">{{item.title}}</div>
					</div>
					<div class="itemDesc ellipsis-3">
						{{item.content}}
					</div>
					<div class="peopleComment">
						<div class="people">
							<img class="peopleIcon" src="../assets/Home/people.png" />
							{{item.user_num}}人
						</div>
						<div class="comment">
							<img class="commentIcon" src="../assets/Home/comment.png" />
							{{item.dt_num}}个
						</div>
					</div>
				</div>
			</div>
			<router-link to="/latform-hypertalk" class="view-more-official">
				查看更多 》
			</router-link>
		</div>
		<!-- 猜你喜欢 -->
		<div class="like-container" v-if="token && userLike.length > 0">
			<div class="container-title-box">
				<div class="title">
					猜你喜欢
					<div class="subTitle">
						YOU MAY ALSO LIKE
					</div>
				</div>
			</div>
			<div class="likeList">
				<OfficalItem class="officalItem" :data="item" v-for="(item,index) in userLike" :key="index">
				</OfficalItem>
			</div>
			<router-link to="/guess-like" class="view-more-official">
				查看更多 》
			</router-link>
		</div>
	</div>
</template>

<script>
	// 引入Swiper库
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import OfficalItem from '../components/OfficalItem.vue'
	export default {
		name: 'HomePage',
		components: {
			OfficalItem,
		},
		data() {
			return {
				token: '',
				banner: [], //轮播图
				artists: [], //画师榜
				huaList: [], //花市推荐
				community: [], //超话
				userLike: [], //猜你喜欢
				swiper: null,
				officialSwiper: null,
				rankTitleData: ['新锐榜', '实力榜', '勤奋榜']
			}
		},
		mounted() {
			this.token = localStorage.getItem('token')
			this.getBanner()
			this.getArtists()
			this.getHuaList()
			this.getCommunity()
			this.getUserLike()
		},
		beforeDestroy() {
			if (this.swiper) {
				this.swiper.destroy(true, true)
			}
			if (this.officialSwiper) {
				this.officialSwiper.destroy(true, true)
			}
		},
		methods: {
			//1外部链接 2作品 3活动 4周边商品 5超话
			naviToBannerDetails(item) {
				if (item.type == 6) return
				if (item.type == 1) {
					window.open(item.mb_id, '_blank');
				} else {
					let url = ''
					if (item.type == 2) {
						url = '/work-details'
					} else if (item.type == 3) {
						url = '/activities-details'
					} else if (item.type == 4) {
						url = '/markets-details'
					} else if (item.type == 5) {
						url = `/super-talk-details?quId=${item.fenqu && item.fenqu.length > 0 ? item.fenqu[0].id : ''}`
					}
					this.$router.push({
						path: url,
						query: {
							id: item.mb_id
						}
					})
				}
			},
			//跳转到画师详情
			naviToPainter(item) {
				this.$router.push({
					path: '/painter-homepage',
					query: {
						id: item.id
					}
				})
			},
			//获取轮播图
			getBanner() {
				this.$api.post('/Other/banner', {}).then(res => {
					if (res.code == 1) {
						this.banner = res.data
						this.$nextTick(() => {
							this.initSwiper()
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//画师榜
			getArtists() {
				this.$api.post('/Other/hua_ph', {
					time_where: 2
				}).then(res => {
					if (res.code == 1) {
						this.artists = []
						this.artists.push({
							title: '新锐榜',
							children: res.data.xinrui
						})
						this.artists.push({
							title: '实力榜',
							children: res.data.shili
						})
						this.artists.push({
							title: '勤奋榜',
							children: res.data.qinfen
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//官方推荐花市
			getHuaList() {
				this.$api.post('/Goods/hua_list', {
					tj_status: 1
				}).then(res => {
					if (res.code == 1) {
						this.huaList = res.data.all_list
						if (this.huaList.length == 0) return
						this.$nextTick(() => {
							this.initOfficialSwiper()
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//平台超话排名
			getCommunity() {
				this.$api.post('/Community/community_pm', {
					tj_status: 1,
					pagesize: 4
				}).then(res => {
					if (res.code == 1) {
						this.community = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//猜你喜欢
			getUserLike() {
				if (!localStorage.getItem('token')) return
				this.$api.post('/Hua/user_like', {
					p: 1
				}).then(res => {
					if (res.code == 1) {
						this.userLike = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//超话详情
			naviToSuperTalkDetails(item) {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/super-talk-details',
						query: {
							id: item.id,
							quId: item.fenqu && item.fenqu.length > 0 ? item.fenqu[0].id : ''
						}
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			initSwiper() {
				// 创建Swiper实例
				this.swiper = new Swiper('.swiper-container', {
					// 轮播图选项
					slidesPerView: 1,
					loop: true,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					// 分页设置
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						// 方形指示器样式
						renderBullet: function(index, className) {
							return '<span class="' + className + '"></span>';
						}
					}
				})
				this.swiper.update()
				this.swiper.updateSlides();
			},
			initOfficialSwiper() {
				// 创建官方推荐Swiper实例
				this.officialSwiper = new Swiper('.swiper-container-official', {
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: -10,
					loop: true,
					autoplay: {
						delay: 50000,
						disableOnInteraction: false
					},
					navigation: {
						nextEl: '.swiper-button-next-official',
						prevEl: '.swiper-button-prev-official',
					},
					effect: 'coverflow',
					coverflowEffect: {
						rotate: 0,
						stretch: 0,
						depth: 100,
						modifier: 3,
						slideShadows: false
					}
				})
				this.officialSwiper.update()
				this.officialSwiper.updateSlides();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.home-container {
		background: #FAEFDD;
	}

	/* Swiper轮播图样式 */
	.swiper-container {
		width: 100%;
		height: 6.8rem;
		overflow: hidden;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	.swiper-slide {
		position: relative;
		width: 100%;
		height: 100%;
		cursor: pointer;
	}

	.carousel-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.carousel-caption {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 2rem;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
		color: white;
	}

	.carousel-caption h3 {
		font-size: 1.5rem;
		margin-bottom: 0.5rem;
	}

	.carousel-caption p {
		font-size: 1rem;
		opacity: 0.9;
	}

	/* 方形指示器样式 */
	.swiper-pagination {
		bottom: .36rem !important;
	}

	::v-deep .swiper-pagination-bullet {
		width: .5rem;
		height: .04rem;
		border-radius: 0 !important;
		background-color: #706614;
		margin: 0 8px !important;
		transition: all 0.3s ease;
	}

	::v-deep .swiper-pagination-bullet:hover {
		background-color: #706614;
		opacity: 1;
	}

	::v-deep .swiper-pagination-bullet-active {
		background-color: #706614 !important;
	}

	.popular-artists-container {
		width: 100%;
		min-height: 10.8rem;
		display: flex;
		flex-direction: column;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.container-title-box {
		margin: 1.2rem auto 0;
		display: flex;
		text-align: center;
		justify-content: center;

		&::before {
			content: '';
			display: inline-block;
			margin-top: .3rem;
			margin-right: .12rem;
			width: 1.65rem;
			height: 0;
			border-top: .01rem dashed #A88653;
			opacity: 0.3;
		}

		&::after {
			content: '';
			display: inline-block;
			margin-top: .3rem;
			margin-left: .12rem;
			width: 1.65rem;
			height: 0;
			border-top: .02rem dashed #A88653;
			opacity: 0.3;
		}

		.title {
			font-weight: 700;
			font-size: .4rem;
			color: #A88653;

			.subTitle {
				font-weight: 400;
				font-size: .14rem;
				color: #A88653;
			}
		}
	}

	/* 官方推荐样式 */
	.offical-recommendation-container {
		width: 100%;
		height: 10.44rem;
		background: #FDFDF4;
		display: flex;
		flex-direction: column;

		.swiper-container-official {
			margin: .6rem auto 0;
			width: 12rem;
			position: relative;
			overflow: hidden;
		}

		.swiper-wrapper {
			height: 100%;
			width: 11rem;
		}

		.swiper-slide {
			width: 3.6rem;
			height: 5.8rem;
			transform: scale(0.8);
			transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
			z-index: 1;
		}

		.swiper-slide-active {
			transform: scale(1);
			z-index: 3;
		}

		.swiper-slide-prev,
		.swiper-slide-next {
			transform: scale(0.8);
			z-index: 2;
		}

		.swiper-slide-duplicate-active {
			transform: scale(1);
			z-index: 3;
		}

		.official-image {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
		}

		/* 导航箭头样式 */
		.swiper-button-prev-official,
		.swiper-button-next-official {
			position: absolute;
			top: 0%;
			width: .6rem;
			height: 100%;
			display: flex;
			align-items: center;
			background: #FDFDF4;
			z-index: 5;

			.arrowIcon {
				margin-left: .01rem;
				margin-right: .01rem;
				width: .36rem;
				height: .36rem;
				cursor: pointer;
			}
		}

		.swiper-button-prev-official {
			left: -.01rem;
			justify-content: flex-start;
		}

		.swiper-button-next-official {
			right: -.01rem;
			justify-content: flex-end;
		}

		.view-more-official {
			margin: .6rem auto;
			font-weight: 400;
			font-size: .16rem;
			color: #A88653;
		}
	}

	@media (max-width: 480px) {
		.rank-container {
			display: flex;
			flex-direction: column;
			margin: .6rem auto 0;
			z-index: 1;

			.rank-item:nth-child(1) .item-title {
				background: #CDBB98;
			}

			.rank-item:nth-child(2) .item-title {
				background: #E6D9C5;
			}

			.rank-item:nth-child(3) .item-title {
				background: #E2DFC6;
			}

			.rank-item {
				margin: 0 .12rem .4rem;
				display: flex;
				flex-direction: column;
				width: 7.68rem;
				height: 14rem;
				background: #FFFFFF;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: .12rem;
				overflow: hidden;

				.item-title {
					width: 100%;
					height: 1.52rem;
					padding-left: .64rem;
					font-weight: 600;
					font-size: .48rem;
					color: #272726;
					line-height: 1.52rem;
				}

				.item-menu {
					height: 1.04rem;
					display: flex;
					align-items: center;
					margin: 0 .64rem;
					border-bottom: 0.01rem solid #EAEAEA;
					font-weight: 500;
					font-size: .32rem;
					color: #333333;

					.rank {
						width: 1.28rem;
						text-align: center;
					}

					.nickname {
						margin-left: 1.36rem;
						width: 3.76rem;
					}
				}

				.item-artists-list {
					height: 10.32rem;
					display: flex;
					flex-direction: column;
					font-weight: 500;
					font-size: .32rem;
					color: #333333;

					.artist {
						margin: 0 .64rem;
						height: 1.04rem;
						display: flex;
						align-items: center;
						border-bottom: 0.01rem solid #EAEAEA;

						.rankText {
							width: 1.28rem;
							display: flex;
							align-items: center;
							justify-content: center;
							font-weight: 400;
							font-size: .32rem;
							color: #6B6C30;

							.rankImg {
								width: .48rem;
								height: .52rem;
							}
						}



						.avatarNickname {
							margin-left: 1.36rem;
							width: 3.76rem;
							display: flex;
							align-items: center;
							cursor: pointer;

							.avatar {
								width: .6rem;
								height: .6rem;
								border-radius: 50%;
							}

							.nickname {
								margin-left: .2rem;
								font-weight: 400;
								font-size: .32rem;
								color: #252525;
							}
						}
					}
				}

				.look-more {
					margin: .32rem auto;
					font-weight: 400;
					font-size: .28rem;
					line-height: .48rem;
					color: #A88653;
				}
			}
		}

		.latform-hypertalk-ranking-container {
			width: 100%;
			min-height: 9.8rem;
			display: flex;
			flex-direction: column;
			align-items: center;

			.view-more-official {
				margin-bottom: .32rem;
				font-weight: 400;
				font-size: .32rem;
				color: #A88653;
			}

			.hypertalkRankingList {
				display: flex;
				flex-wrap: wrap;
				margin: .6rem auto;

				.hypertalkRankingItem {
					display: flex;
					flex-direction: column;
					align-items: center;
					position: relative;
					margin: .24rem .36rem 0;
					cursor: pointer;

					.itemIcon {
						width: 5.64rem;
						height: 7.56rem;
						border-radius: 2.82rem;
						object-fit: cover;
					}

					.itemTitleBox {
						position: absolute;
						top: 3rem;
						display: flex;
						flex-direction: column;
						font-size: .48rem;
						color: #FFFFFF;
						text-align: center;

						.title {
							font-weight: 400;
							line-height: .64rem;
						}

						.cate {
							font-weight: 600;
							margin-top: .48rem;
							line-height: .64rem;
						}
					}

					.itemDesc {
						margin-top: .64rem;
						width: 4.52rem;
						height: 1.32rem;
						font-weight: 400;
						font-size: .32rem;
						color: #333333;
						line-height: .42rem;
						text-align: center;
					}

					.peopleComment {
						margin-top: .4rem;
						display: flex;
						align-items: center;

						.people,
						.comment {
							margin-left: .2rem;
							margin-right: .2rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .28rem;
							color: #7C400E;
							line-height: .4rem;
						}

						.peopleIcon,
						.commentIcon {
							width: .32rem;
							height: .32rem;
							margin-right: .16rem;
						}
					}
				}
			}
		}

		.like-container {
			width: 100%;
			// height: 15.2rem;
			background: #FDFDF4;
			display: flex;
			flex-direction: column;
			align-items: center;

			.likeList {
				margin-top: .28rem;
				width: 12rem;
				display: flex;
				flex-wrap: wrap;

				.officalItem:nth-child(2n) {
					margin-right: 0;
				}
			}

			.view-more-official {
				margin: .6rem auto;
				font-weight: 400;
				font-size: .32rem;
				color: #A88653;
			}
		}
	}

	@media (min-width: 481px) {
		.rank-container {
			display: flex;
			align-items: center;
			margin: .6rem auto 0;
			z-index: 1;

			.rank-item:nth-child(1) .item-title {
				background: #CDBB98;
			}

			.rank-item:nth-child(2) .item-title {
				background: #E6D9C5;
			}

			.rank-item:nth-child(3) .item-title {
				background: #E2DFC6;
			}

			.rank-item {
				margin: 0 .12rem;
				display: flex;
				flex-direction: column;
				width: 3.84rem;
				height: 7rem;
				background: #FFFFFF;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: .12rem;
				overflow: hidden;

				.item-title {
					width: 100%;
					height: .76rem;
					padding-left: .32rem;
					font-weight: 600;
					font-size: .24rem;
					color: #272726;
					line-height: .76rem;
				}

				.item-menu {
					height: .52rem;
					display: flex;
					align-items: center;
					margin: 0 .32rem;
					border-bottom: 0.01rem solid #EAEAEA;
					font-weight: 500;
					font-size: .16rem;
					color: #333333;

					.rank {
						width: .64rem;
						text-align: center;
					}

					.nickname {
						margin-left: .68rem;
						width: 1.88rem;
					}
				}

				.item-artists-list {
					height: 5.16rem;
					display: flex;
					flex-direction: column;
					font-weight: 500;
					font-size: .16rem;
					color: #333333;

					.artist {
						margin: 0 .32rem;
						height: .52rem;
						display: flex;
						align-items: center;
						border-bottom: 0.01rem solid #EAEAEA;

						.rankText {
							width: .64rem;
							display: flex;
							align-items: center;
							justify-content: center;
							font-weight: 400;
							font-size: .16rem;
							color: #6B6C30;

							.rankImg {
								width: .24rem;
								height: .26rem;
							}
						}



						.avatarNickname {
							margin-left: .68rem;
							width: 1.88rem;
							display: flex;
							align-items: center;
							cursor: pointer;

							.avatar {
								width: .3rem;
								height: .3rem;
								border-radius: 50%;
							}

							.nickname {
								margin-left: .1rem;
								font-weight: 400;
								font-size: .16rem;
								color: #252525;
							}
						}
					}
				}

				.look-more {
					margin: .16rem auto;
					font-weight: 400;
					font-size: .14rem;
					line-height: .24rem;
					color: #A88653;
				}
			}
		}

		.latform-hypertalk-ranking-container {
			width: 100%;
			height: 9.8rem;
			display: flex;
			flex-direction: column;
			align-items: center;

			.view-more-official {
				font-weight: 400;
				font-size: .16rem;
				color: #A88653;
			}

			.hypertalkRankingList {
				display: flex;
				align-items: center;
				margin: .6rem auto;

				.hypertalkRankingItem {
					display: flex;
					flex-direction: column;
					align-items: center;
					position: relative;
					margin: 0 .12rem;
					cursor: pointer;

					.itemIcon {
						width: 2.82rem;
						height: 3.78rem;
						border-radius: 1.41rem;
						object-fit: cover;
					}

					.itemTitleBox {
						position: absolute;
						top: 1.5rem;
						display: flex;
						flex-direction: column;
						font-size: .24rem;
						color: #FFFFFF;
						text-align: center;

						.title {
							font-weight: 400;
							line-height: .32rem;
						}

						.cate {
							font-weight: 600;
							margin-top: .24rem;
							line-height: .32rem;
						}
					}

					.itemDesc {
						margin-top: .32rem;
						width: 2.26rem;
						height: .66rem;
						font-weight: 400;
						font-size: .16rem;
						color: #333333;
						line-height: .22rem;
						text-align: center;
					}

					.peopleComment {
						margin-top: .2rem;
						display: flex;
						align-items: center;

						.people,
						.comment {
							margin-left: .1rem;
							margin-right: .1rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #7C400E;
							line-height: .2rem;
						}

						.peopleIcon,
						.commentIcon {
							width: .16rem;
							height: .16rem;
							margin-right: .08rem;
						}
					}
				}
			}
		}

		.like-container {
			width: 100%;
			// height: 15.2rem;
			background: #FDFDF4;
			display: flex;
			flex-direction: column;
			align-items: center;

			.likeList {
				margin-top: .28rem;
				width: 12rem;
				display: flex;
				flex-wrap: wrap;

				.officalItem:nth-child(4n) {
					margin-right: 0;
				}
			}

			.view-more-official {
				margin: .6rem auto;
				font-weight: 400;
				font-size: .16rem;
				color: #A88653;
			}
		}
	}
</style>